class MFRCommentForm {
  constructor(index, element) {
    this.$index = index;
    this.$element = $(element);

    this.selectors = {
      body: '[name="comment[body]"]',
      stars: '[name="stars"]',
      title: '[name="title"]',
      content: '[name="content"]',
      checkedStars: '[name="stars"]:checked',
    };

    this.init();
  }

  init() {
    this.$body = this.$element.find(this.selectors.body);
    this.$stars = this.$element.find(this.selectors.stars);
    this.$title = this.$element.find(this.selectors.title);
    this.$content = this.$element.find(this.selectors.content);

    this.updateBody();

    this.$stars.on("change", this.updateBody.bind(this));
    this.$title.on("input", this.updateBody.bind(this));
    this.$content.on("input", this.updateBody.bind(this));
  }

  updateBody() {
    const bodyContent = `${this.$element
      .find(this.selectors.checkedStars)
      .val()}|${this.$title.val()}|${this.$content.val()}`;
    this.$body.val(bodyContent);
  }
}